import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.scss";
import { getApiInstance } from "../../utils/api";
import Input from "../../components/common/Inputs/Input/Input";
import Button from "../../components/common/Button/Button";

import {
  FaFileAlt,
  FaUsersCog,
  FaIndustry,
  FaBalanceScale,
  FaFolderOpen,
  FaCalculator,
} from "react-icons/fa";
import { TbUserSquareRounded } from "react-icons/tb";
import InputCheckbox from "../../components/common/Inputs/InputCheckbox/InputCheckbox";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const api = getApiInstance();
    try {
      const response = await api.post("/api/Auth", {
        email: username,
        password: password,
      });

      const { token } = response.data;
      localStorage.setItem("token", token);
      onLogin(token);
      navigate("/");
    } catch (error) {
      setError(
        "Error al iniciar sesión. Por favor, verifica tus credenciales."
      );
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__left">
        <div className="login-page__left__logo">
          <img
            src="/waste-life-cycle-logotipo-cut.png"
            alt="Waste Life Cycle Logo"
            className="login-page__left__logo__img"
          />
          <h1 className="login-page__left__logo__text">Waste Life Cycle</h1>
        </div>

        <div className="login-page__left__welcome">
          <h2>Tu plataforma de gestión de residuos</h2>
          <h3>
            La solución integral para gestionar tus residuos de forma eficiente
          </h3>

          <div className="login-page__left__welcome__features">
            <div className="login-page__left__welcome__features__feature">
              <FaFileAlt size={28} />
              <p>Informes</p>
            </div>
            <div className="login-page__left__welcome__features__feature">
              <FaUsersCog size={28} />
              <p>Gestores</p>
            </div>
            <div className="login-page__left__welcome__features__feature">
              <FaIndustry size={28} />
              <p>Centros de Producción</p>
            </div>
            <div className="login-page__left__welcome__features__feature">
              <FaBalanceScale size={28} />
              <p>Cumplimiento Legal</p>
            </div>
            <div className="login-page__left__welcome__features__feature">
              <FaFolderOpen size={28} />
              <p>Gestión documental</p>
            </div>
            <div className="login-page__left__welcome__features__feature">
              <FaCalculator size={28} />
              <p>Control de Costes</p>
            </div>
          </div>

          <a
            href="https://wastelifecycle.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="button-link"
          >
            <button className="button secondary default">
              Ver manual de uso
            </button>
          </a>
        </div>
      </div>

      <div className="login-page__right">
        <div className="login-form">
          <div className="login-form__header">
            <TbUserSquareRounded size={56} color="#646266" />
            <h1 className="login-form__title">Inicia sesión para continuar</h1>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="login-form__inputs">
              <div className="login-form__inputs">
                <Input
                  name="email"
                  type="email"
                  label="Email"
                  placeholder="Ex.: example@email.com"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <Input
                  name="password"
                  type="password"
                  label="Contraseña"
                  placeholder="Ex.: 123456"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="login-form__options">
                <InputCheckbox
                  name="rememberMe"
                  id="rememberMe"
                  label="Mantener sesión iniciada"
                  spacing="8px"
                />
                <a href="/forgot-password" className="login-form__forgot">
                  ¿Olvidaste tu contraseña?
                </a>
              </div>
              {error && <div className="login-form__error">{error}</div>}
              <Button
                variant="filled"
                type="submit"
              >
                Iniciar sesión
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;